import { NavLink } from "react-router-dom";
import '../styles/Layout.css'
import pwcLogo from '../assets/png/logo_pwc_blk.png'
import logoutIcon from '../assets/png/ico_logout.png'
import kbIcon from '../assets/png/ico_kb_accelerator.png'
import { useLocation } from 'react-router-dom';
import codeLineageIcon from '../assets/png/ico_codelineage.png'
import { useNavigate } from "react-router";

const Header = () => {
  let navigate = useNavigate();
  const { pathname } = useLocation();

  const to =
    pathname.startsWith('/insight-hub') ? '/lineage-studio' : '/insight-hub';

  const label =
    pathname.startsWith('/insight-hub') ? 'Lineage Studio' : 'Insight Hub';

  return (
    <nav class="navbar navbar-expand-lg header-navbar-bg p-0 header-main">
      <div class="container-fluid">
        <button class="navbar-toggler me-2" type="button" data-bs-toggle="offcanvas" data-bs-target="#sidebarMenu" aria-controls="sidebarMenu">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div className="headerLeftSection">
          <div className="logo-section">
            <img src={pwcLogo} alt="pwc logo" className="header-pwc-img" width={100}
              onClick={() => navigate('/home')}
            />
          </div>
          <div className="header-label">
            <i className="headerLogo"></i>
          </div>
          <div className="border-right"></div>
          <div className="header-label">
            <label className="header-label-text2">Know the system like its creator!</label>
          </div>
        </div>
        <div className="col-4 d-flex justify-content-end d-none d-lg-flex">
          <div className="right-section">
            <nav className="headerNav">
              <NavLink
                to={to}
                className={({ isActive }) => (isActive ? 'headerNavLink active' : 'headerNavLink')}
              >
                <span className="headerNavText">
                  <img
                    src={label === 'Insight Hub' ? kbIcon : label === 'Lineage Studio' ? codeLineageIcon : kbIcon}
                    alt={`${label} Icon`}
                    className="kb-icon"
                  />
                  {label}
                </span>
              </NavLink>
            </nav>
          </div>
          <div className="d-flex align-items-center">
            <img src={logoutIcon} alt="logout" height={16} className="logout-icon" />
          </div>
        </div>
        <div class="offcanvas offcanvas-start header-navbar-bg2 text-white d-lg-none" tabindex="-1" id="sidebarMenu" aria-labelledby="sidebarMenuLabel">
          <div class="offcanvas-header">
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
          </div>
          <div className="offcanvas-body">
            <ul className="navbar-nav-small">
              <li className="nav-item">
                <NavLink
                  to="/"
                  className={({ isActive }) => (isActive ? "navlink active" : "navlink")}
                >
                  {({ isActive }) => (
                    <>
                      <i className={isActive ? "homeIconActive" : "homeIcon"}></i >Home
                    </>
                  )}
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  to="/insight-hub"
                  className={({ isActive }) => (isActive ? "navlink active" : "navlink")}
                >
                  {({ isActive }) => (
                    <>
                      <i className={isActive ? "kbMenuActive" : "kbMenu"}></i> Insight Hub
                    </>
                  )}
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  to="/lineage-studio"
                  className={({ isActive }) => (isActive ? "navlink active" : "navlink")}
                >
                  {({ isActive }) => (
                    <>
                      <i className={isActive ? "clMenuActive" : "clMenu"}></i> Lineage Studio
                    </>
                  )}
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  to="/advanced-lineage-studio"
                  className={({ isActive }) => (isActive ? "navlink active" : "navlink")}
                >
                  {({ isActive }) => (
                    <>
                      <i className={isActive ? "aclMenuActive" : "aclMenu"}></i>Advanced Lineage Studio
                    </>
                  )}
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;

